import { css, DefaultTheme } from 'styled-components';

export const btnType = (theme: DefaultTheme, style: string) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.buttons.backgroundColors[style],
  color: theme.buttons.fontColors[style],
  border: `${theme.buttons.borderWidth} solid ${theme.buttons.borderColors[style]}`,
  borderRadius: theme.buttons.borderRadius,
  fontFamily: "'Satoshi-Black', sans-serif",
  textTransform: 'uppercase',
  '&:not(:disabled):hover': {
    backgroundColor: theme.buttons.hoverBackgroundColors[style],
    borderColor: theme.buttons.hoverBorderColors[style],
  },
  '&:not(:disabled):active': {
    backgroundColor: theme.buttons.focusBackgroundColors[style],
    borderColor: theme.buttons.focusBorderColors[style],
  },
});

export const btnSize = (theme: DefaultTheme, size: string) => ({
  padding: theme.buttons.paddings[size],
  fontSize: theme.buttons.fontSizes[size],
  lineHeight: theme.buttons.lineHeights[size],
});

export const btn = (type: string, size: string = 'medium') => css`
  ${(p) => btnType(p.theme, type)}
  ${(p) => btnSize(p.theme, size)}
`;
